import useFullScreen from '@toluade/use-fullscreen';
import AppBar from '@material-ui/core/AppBar';
import { ThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { memo } from 'react';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { selectFooterTheme } from 'app/store/fuse/settingsSlice';
import clsx from 'clsx';
import moment from 'moment';

function FooterLayout1(props) {
	const footerTheme = useSelector(selectFooterTheme);
	const { isFullScreen } = useFullScreen('root');
	if (!isFullScreen)
		return (
			<ThemeProvider theme={footerTheme}>
				<AppBar id="fuse-footer" className={clsx('relative z-20 shadow-md', props.className)} color="default" style={{ backgroundColor: footerTheme.palette.background.paper }}>
					<Toolbar className="min-h-0 py-8 px-8 md:px-12 flex flex-col md:flex-row gap-4 items-center justify-between overflow-x-auto">
						<Typography className='text-xs'>
							{`Dashboard by `}
							<a href="https://creo.hu" target="_blank" rel="noreferrer" style={{ background: 'none', fontWeight: 'bold' }}>Creo Group</a>
							{` - © ${new Date().getFullYear()}`}
						</Typography>
						<Typography className='opacity-25 px-2 text-xs text-center md:text-left'>
							Build Version: {process.env.REACT_APP_BUILD_VERSION || '?'} | environment: {process.env.REACT_APP_ENVIRONMENT || '?'} | time: {process.env.REACT_APP_BUILD_DATE ? (moment(process.env.REACT_APP_BUILD_DATE).format('YYYY.MM.DD HH:mm')) : '?'}
						</Typography>
					</Toolbar>
				</AppBar>
			</ThemeProvider>
		);
	return <></>;
}

export default memo(FooterLayout1);
